import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

import styles from './CustomHeader.module.scss';

export const CustomHeader = ({
  text,
  tooltip,
}: {
  text: string;
  tooltip?: string;
}) => (
  <div className={styles.customHeader}>
    <span className={styles.headerTitle}>{text}</span>
    {tooltip && (
      <Tooltip title={tooltip}>
        <QuestionCircleOutlined />
      </Tooltip>
    )}
  </div>
);
